import { render, staticRenderFns } from "./riskDialog.vue?vue&type=template&id=34a09378"
import script from "./riskDialog.vue?vue&type=script&lang=js"
export * from "./riskDialog.vue?vue&type=script&lang=js"
import style0 from "./riskDialog.vue?vue&type=style&index=0&id=34a09378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports